function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.1",
  id: "Hair_straightener",
  xmlns: "http://www.w3.org/2000/svg",
  x: "0",
  y: "0",
  viewBox: "0 0 283.5 283.5",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M63.612 91.785v-14.5a3.385 3.385 0 003.38-3.381 3.385 3.385 0 00-3.38-3.382c-9.87 0-17.892-8.022-17.892-17.882s8.022-17.881 17.882-17.881a3.39 3.39 0 003.4-3.382 3.385 3.385 0 00-3.381-3.382v-14.5c9.86 0 17.881 8.022 17.881 17.882s-8.021 17.881-17.881 17.881a3.39 3.39 0 00-3.4 3.382 3.385 3.385 0 003.381 3.382c9.87 0 17.89 8.022 17.89 17.881s-8.02 17.882-17.88 17.882zM99.076 14.008h14.5v77.776h-14.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.099 183.761h120.365v14.5H163.099z"
}), /*#__PURE__*/React.createElement("path", {
  transform: "rotate(-20.182 217.428 127.226)",
  d: "M149.778 119.981h135.34v14.5h-135.34z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.762 205.338a42.383 42.383 0 002.407-14.092c0-10.27-3.654-19.702-9.73-27.065l200.487-73.6-9.818-26.748-237.066 87.048C12.182 156.553 0 172.498 0 191.245c0 23.266 18.756 42.222 41.941 42.57l241.524.016v-28.493H82.762zm-54.27-14.093c0-7.77 6.323-14.092 14.093-14.092s14.092 6.322 14.092 14.093-6.321 14.092-14.092 14.092-14.093-6.322-14.093-14.093z"
})));